import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useRequestData, useLabels } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import { validateZip } from '../../utilities/validate-zip';

const LocationInputInline = ({
	location,
	updateLocation,
	setInvalidZipError
}) => {
	const { widgetName, windowId } = useRequestData();
	const labels = useLabels();
	const [input, setInput] = useState(location?.[0] || '');
	const [targetElement, setTargetElement] = useState(null);

	const handleKeyPress = (e) => {
		e.preventDefault();

		if (e.key === 'Enter') {
			const newInput = e.target.value;
			const isValidZip = validateZip(newInput);

			if (newInput !== input && isValidZip) {
				setInput(newInput);
				setTargetElement(e.target);
			} else if (!isValidZip) {
				setInvalidZipError(true);
			}
		}
	};

	useEffect(() => {
		if (input && targetElement) {
			const isValidZip = validateZip(input);
			if (isValidZip) {
				updateLocation(input, targetElement);
				setInvalidZipError(false);

				trackEvent(widgetName, windowId, {
					action: 'applied',
					element: 'Zip Code selection',
					elementCTA: 'Text input',
					result: 'Results updated with facet added'
				});
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [input, targetElement, widgetName, windowId]);

	const form = (
		<form
			className="location-input-form p-0 mt-3 mt-lg-0 ml-lg-3"
			onSubmit={(e) => {
				e.preventDefault();
			}}
		>
			<span className="ddc-font-size-xsmall">
				{labels.get('GEO_ZIP_CAPS')}
			</span>
			<input
				className="form-control p-3"
				type="search"
				aria-label={labels.get('ENTER_A_NEW_ZIP_CODE')}
				onKeyUp={handleKeyPress}
				placeholder={input}
			/>
		</form>
	);
	return <span>{form}</span>;
};

LocationInputInline.propTypes = {
	location: PropTypes.arrayOf(PropTypes.string).isRequired,
	updateLocation: PropTypes.func.isRequired,
	setInvalidZipError: PropTypes.func.isRequired
};

export default LocationInputInline;
